import React from 'react';
import { RadioGroupItem } from './Radio';
import CarCard from '../cars/carCard';

/* export const CardTag = ({ isAssigned, id }) => {
  return (
    <div className="flex justify-between">
      {isAssigned ? (
        <div
          className="flex flex-col items-center gap-2 rounded-br-lg py-1.5 ps-3 pe-4 rounded-tl-lg"
          style={{ boxShadow: '-1px -1px 2px 0px rgba(0, 0, 0, 0.07) inset' }}
        >
          <div className="rounded bg-success w-2 h-2"></div>
          <span className="text-grenite text-disclaimer">Assigned</span>
        </div>
      ) : (
        <div
          className="flex items-center gap-2 rounded-br-lg py-1.5 ps-3 pe-4 rounded-tl-lg"
          style={{ boxShadow: '-1px -1px 2px 0px rgba(0, 0, 0, 0.07) inset' }}
        >
          <div className="rounded bg-primary w-2 h-2 text-grenite text-disclaimer"></div>
          <span className="text-grenite text-disclaimer">Un-assigned</span>
        </div>
      )}
      <div className="py-1.5 pe-4">
        <RadioGroupItem value={id} id={id} />
      </div>
    </div>
  );
}; */

export const CardTag = (props) => {
  return (
    <div className="flex justify-between">
      <CarCard {...props} />
      <div className="py-1.5 pe-4">
        <RadioGroupItem value={props.id} id={props.id} />
      </div>
    </div>
  );
};
